import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';

import { version as LOCAL_APP_VERSION } from '../../package.json';

import { Firestore } from 'utlis/firebase';

// Returns true only if remote version is strictly newer than local.
const isNewerVersion = (a, b) => !!a && !!b && a.localeCompare(b, undefined, { numeric: true }) > 0;

/**
 * Listens to deployments/currentVersion in Firestore in real time.
 * Compares the remote version against the local version from package.json.
 * Returns true only when the remote is strictly newer — a rollback on Firebase
 * will never prompt users to update.
 * The listener is cleaned up automatically when the component unmounts.
 */
const useVersionCheck = () => {
  const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);

  useEffect(() => {
    if (!Firestore) {
      return undefined;
    }

    const versionDocRef = doc(Firestore, 'deployments', 'currentVersion');

    const unsubscribe = onSnapshot(
      versionDocRef,
      snapshot => {
        if (!snapshot.exists()) {
          return;
        }

        const remoteVersion = snapshot.data()?.version;

        setIsUpdateAvailable(isNewerVersion(remoteVersion, LOCAL_APP_VERSION));
      },
      // eslint-disable-next-line no-console
      error => console.warn('[VersionCheck] Firestore listener error:', error)
    );

    return unsubscribe;
  }, []);

  return isUpdateAvailable;
};

export default useVersionCheck;
